/* sb-dc-nofintab.js - no Finishing tab on products that have no finishing.
   2026-09-22 (v1).

   WHAT WAS WRONG (measured 2026-09-22, Chrome, tab visible)
   Opening a feather flag - with or without ?tpl= - the left rail showed a
   Finishing button (button.rail-btn, 54x60, display:flex). Clicking it opened
   the banner list: Hem + Grommets, Hem only, Grommets only, No hem. A flag is
   sewn into a pole sleeve; none of those exist.

   Everything else already knew the product has no finishing:
     window.__CAT item feather-angled-flag-large   noFinishing: true
     window.__dcFinishingAllowed()                 []   (sb-dc-flagopts.js)
     api.spec.finishing                            'none'
     right-rail card (sb-dc-finrail.js)            removed
   Only the left rail button had nobody looking after it. The Templates button
   in the same rail is hidden with display:none; this does the same for
   Finishing.

   RULE
   The button is hidden when the product on the board says it has no
   finishing - its catalogue entry has noFinishing, or the allowed list is
   empty. Nothing is decided until both the applied product and the allowed
   list exist, so a banner never has its tab flicker off while the page is
   still booting. If the Finishing panel happens to be the one open when the
   tab goes, the Size panel is opened instead so the customer is not left
   looking at options for something that is no longer there.

   Only the button is touched. The finishing value itself is already 'none'
   and is left to the files that own it.

   Diagnostics: window.__dcNoFinTab() */
(function () {
  'use strict';

  var info = { handle: '', off: null, hidden: 0, restored: 0, switched: 0, why: '' };
  window.__dcNoFinTab = function () { return info; };

  function applied() {
    try {
      var p = window.__dcAppliedProduct && window.__dcAppliedProduct();
      return (p && p.handle) || '';
    } catch (e) { return ''; }
  }

  function catItem(h) {
    var item = null;
    try {
      (window.__CAT || []).forEach(function (c) {
        (c.items || []).forEach(function (it) { if (it && it.handle === h) item = it; });
      });
    } catch (e) {}
    return item;
  }

  /* null = not known yet (leave the button alone), true / false = decided */
  function noFinishing() {
    var h = applied();
    if (!h) return null;
    info.handle = h;
    var it = catItem(h);
    if (it && it.noFinishing) return true;
    if (typeof window.__dcFinishingAllowed !== 'function') return null;
    var ids;
    try { ids = window.__dcFinishingAllowed(); } catch (e) { return null; }
    if (!Array.isArray(ids)) return null;
    return ids.length === 0;
  }

  function railButtons() {
    return document.querySelectorAll('button.rail-btn');
  }

  function findBtn(re) {
    var bs = railButtons();
    for (var i = 0; i < bs.length; i++) {
      if (re.test((bs[i].textContent || '').trim())) return bs[i];
    }
    return null;
  }

  function tick() {
    var btn = findBtn(/^Finishing$/i);
    if (!btn) return;
    var off = noFinishing();
    if (off === null) return;
    info.off = off;

    if (off) {
      if (btn.style.display !== 'none') {
        /* If its panel is the open one, move to Size first. */
        if (btn.getAttribute('aria-pressed') === 'true') {
          var size = findBtn(/^Size$/i);
          if (size) { try { size.click(); info.switched++; } catch (e) {} }
        }
        btn.style.display = 'none';
        btn.dataset.sbdcNofin = '1';
        info.hidden++;
      }
    } else if (btn.dataset.sbdcNofin === '1') {
      /* Only undo our own hiding - never unhide something another file hid. */
      btn.style.display = '';
      delete btn.dataset.sbdcNofin;
      info.restored++;
    }
  }

  var t = setInterval(function () { try { tick(); } catch (e) { info.why = String(e && e.message); } }, 250);
  window.addEventListener('pagehide', function () { clearInterval(t); });
})();
